import React from 'react';

const BlogTopHeader = ({ children }) => {
  return (
    <header className="blog-header">
      <div style={{ zIndex: '1000000000' }}>
        <div className="header-main header-div">
          <nav className="nav-container">
            <div
              className="flex-row justify-content-between align-items-center"
              style={{ display: 'flex', justifyContent: 'center' }}>
              <div
                className="menu-main"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  paddingRight: '40px',
                }}>
                <div className="main-nav">{children}</div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default BlogTopHeader;
